module.exports = __webpack_public_path__ + "img/cb-play.f47ff0a5.svg";